import { defineComponent as _defineComponent } from 'vue'

import { Competition } from '@ilteducation/competition-referee-types';

type Props = {
  id: string;
  title: string;
  item: Competition;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  item: Competition;
}



return { __sfc: true,props }
}

})